/**
 * Private Excel upload for Admin Prospection import (Lot 6.6B.1).
 * PUT/POST the selected file to a short-lived server-signed URL.
 * Do not log the URL, file name, or bytes.
 */

import { httpsCallable } from 'firebase/functions';
import { functions } from '../../config/firebase';
import {
  buildSignedPostUploadForm,
  signedPostUploadFetchInit,
} from './prospectImportUploadForm';

export async function createAdminProspectImportUpload(payload) {
  const fn = httpsCallable(functions, 'createAdminProspectImportUpload');
  const { data } = await fn(payload);
  return data;
}

export async function parseAdminProspectImportFile(payload) {
  const fn = httpsCallable(functions, 'parseAdminProspectImportFile');
  const { data } = await fn(payload);
  return data;
}

export async function uploadProspectImportSource({ upload, file, contentType } = {}) {
  if (!upload || typeof upload.url !== 'string' || !upload.url) {
    const error = new Error('upload unavailable');
    error.code = 'upload_failed';
    throw error;
  }
  const method = String(upload.method || 'PUT').toUpperCase();
  if (method === 'POST') {
    const form = buildSignedPostUploadForm({ fields: upload.fields, file });
    const res = await fetch(upload.url, signedPostUploadFetchInit(form));
    if (!res.ok) {
      const error = new Error('upload failed');
      error.code = 'upload_failed';
      throw error;
    }
    return;
  }
  const headers = {
    ...(upload.headers && typeof upload.headers === 'object' && !Array.isArray(upload.headers)
      ? upload.headers
      : {}),
  };
  if (contentType) headers['Content-Type'] = contentType;
  const res = await fetch(upload.url, { method, headers, body: file });
  if (!res.ok) {
    const error = new Error('upload failed');
    error.code = 'upload_failed';
    throw error;
  }
}
